// extracted by mini-css-extract-plugin
export default {"Home":"Home_Home__pC8Kc","arrowToTop":"Home_arrowToTop__ulV01","icon":"Home_icon__d3NVO"};